import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import escapeRegExp from 'lodash/escapeRegExp';
import uuidv5 from 'uuid/v5';
import getDocumentPosition from '../plugins/common/get-document-position';
import { getNodeText } from '../utils/document-text';
// Unique namespace to identify JQL autocomplete options!
var UUID_NAMESPACE = '9a90299c-aa58-494b-b6a1-e93206e3fdd6';
export var getAutocompleteOptionId = function getAutocompleteOptionId(value) {
  return uuidv5(value, UUID_NAMESPACE);
};
export var tokensToAutocompleteOptions = function tokensToAutocompleteOptions(tokens) {
  var tokensToDisplay = tokens.values;

  if (tokens.matchedText !== '') {
    // Candidates that start with last token text but are not an exact match (case insensitive)
    var regex = new RegExp("^".concat(escapeRegExp(tokens.matchedText), "[^$]"), 'i');
    tokensToDisplay = tokens.values.filter(function (token) {
      return regex.test(token);
    });
  }

  return tokensToDisplay.map(function (token) {
    var _tokens$context;

    return {
      id: getAutocompleteOptionId(token),
      name: token,
      value: token,
      replacePosition: tokens.replacePosition,
      matchedText: tokens.matchedText,
      context: (_tokens$context = tokens.context) !== null && _tokens$context !== void 0 ? _tokens$context : null,
      type: 'keyword'
    };
  });
};
export var getReplacePositionStart = function getReplacePositionStart(_ref) {
  var rules = _ref.rules,
      tokens = _ref.tokens;

  // Matching tokens should be prioritized over rules when calculating autocomplete dropdown position
  if (tokens.values.length) {
    return tokens.replacePosition[0];
  } // Same precedence as `useAutocompleteOptions`, this may change in future if we don't limit suggestions to one rule


  var rulePrecedence = ['value', 'function', 'list', 'operator', 'field'];

  for (var _i = 0, _rulePrecedence = rulePrecedence; _i < _rulePrecedence.length; _i++) {
    var rule = _rulePrecedence[_i];

    if (Object.prototype.hasOwnProperty.call(rules, rule)) {
      return rules[rule].replacePosition[0];
    }
  }

  return tokens.replacePosition[0];
};
export var getAutocompletePosition = function getAutocompletePosition(editorView, replacePositionStart) {
  var _editorView$state = editorView.state,
      doc = _editorView$state.doc,
      selection = _editorView$state.selection;
  var documentPosition = getDocumentPosition(doc, replacePositionStart);

  var _editorView$coordsAtP = editorView.coordsAtPos(documentPosition),
      left = _editorView$coordsAtP.left; // Vertically position autocomplete relative to selection end


  var _editorView$coordsAtP2 = editorView.coordsAtPos(selection.to),
      bottom = _editorView$coordsAtP2.bottom;

  return {
    top: bottom,
    left: left
  };
};

var getDebugSelectionAttributes = function getDebugSelectionAttributes() {
  var _selection$anchorNode, _selection$anchorNode2, _selection$focusNode, _selection$focusNode2;

  var selection = document.getSelection();

  if (selection === null || selection.type === 'None') {
    return {};
  }

  return {
    anchorOffset: selection.anchorOffset,
    anchorNodeText: (_selection$anchorNode = selection.anchorNode) === null || _selection$anchorNode === void 0 ? void 0 : _selection$anchorNode.textContent,
    anchorNodeName: (_selection$anchorNode2 = selection.anchorNode) === null || _selection$anchorNode2 === void 0 ? void 0 : _selection$anchorNode2.nodeName,
    focusOffset: selection.focusOffset,
    focusNodeText: (_selection$focusNode = selection.focusNode) === null || _selection$focusNode === void 0 ? void 0 : _selection$focusNode.textContent,
    focusNodeName: (_selection$focusNode2 = selection.focusNode) === null || _selection$focusNode2 === void 0 ? void 0 : _selection$focusNode2.nodeName
  };
};

export var sendDebugMessage = function sendDebugMessage(message, editorView, editorState, onDebugUnsafeMessage, eventAttributes) {
  if (!onDebugUnsafeMessage) {
    return;
  }

  try {
    var editorViewStateText = getNodeText(editorView.state.doc, 0, editorView.state.doc.content.size);
    var editorViewStateJson = JSON.stringify(editorView.state.toJSON());
    var editorStateJson = JSON.stringify(editorState.toJSON());
    var editorViewHtml = editorView.dom.innerHTML;
    onDebugUnsafeMessage(message, _objectSpread(_objectSpread({
      editorStateJson: editorStateJson,
      editorViewStateText: editorViewStateText,
      editorViewStateJson: editorViewStateJson,
      editorViewHtml: editorViewHtml
    }, getDebugSelectionAttributes()), eventAttributes));
  } catch (ignored) {// Do nothing
  }
};